

const yearOptions = [{ id: 2024, name: "2024" }, { id: 2025, name: "2025" }]
const semesterAndYearOptions = [
    {
        id: 2025, name: "2024-2025", label: "2024-2025"
    },
    {
        id: 2026, name: "2025-2026", label: "2025-2026"
    },
    {
        id: 2027, name: "2026-2027", label: "2026-2027"
    }
]

export { yearOptions, semesterAndYearOptions }